module.exports = __webpack_public_path__ + "img/microwaver-error.f92e3c6.png";